export default __webpack_public_path__ + "static/media/tag.42ecf998.png";